'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import TechnologyFaq from '@/components/technologies/technology-faq';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import FlutterFAQ from '@/components/faqs/flutter-faq';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import CreatePowerFully from '@/components/technologies/flutter-create-powerfully';
import FlutterServies from '@/components/technologies/flutter-demand';

import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';
const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));
const TechHero = dynamic(() => import('@/components/technologies/tech-hero'));
const Page = () => {
    return (
        <>
            <MetaTags />

            <TechHero
                className=""
                desc="Craft High-Performance Cross-Platform Apps. Develop modern iOS and Android mobile apps with our Flutter app development services. With a single codebase and a full-cycle development process, we build best-in-class apps quickly and efficiently."
                alt="Flutter App"
                title="Flutter App"
                width={643}
                height={603}
                path={'flutter-hero'}
                bgPath={'hero-bg-grunge'}
            >
                Flutter App Development<div> Company</div>
            </TechHero>
            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="Flutter" />
            <CreatePowerFully title="Create Powerfully & Natively Compiled Experiences Using Flutter's Dart SDK" />
            <FlutterServies />
            <HireProcess
                bg="bg-flutterapp"
                pageTitle="Hire Flutter App Developers To Scale Your Business"
                desc="Get a free consultation for your Flutter app design and development project. Our experts will discuss your business requirements to create a robust flutter app with quality."
                ndaText="Ensuring the protection of your data is one of the most critical steps in our process."
                discussingRequirementText="  Now that we have your goals, it's time to get started and work hard to achieve them."
                designingText="Creating a great design is more than just aesthetics."
                developmentText=" Just like building brick and mortar, well-written code makes the difference."
                deploymentText=" It's time to launch your application, build momentum, and move mountains."
                supportAndMaintenanceText="We provide extensive support and maintenance services post-project deployment."
            />
            <WhyChooseUs
                pageTitle="Why Choose Moweb For Flutter Application Development?"
                onTimeDelivery=" At Moweb, we are committed to delivering projects on time and within budget. We ensure meticulous planning, allowing us to align your project with set timelines and costs without sacrificing quality. "
                tailoredBusinessExcellence=" Our solutions are designed to meet your unique business needs. We pride ourselves on delivering custom Flutter apps that provide lasting value and ensure your business stays competitive in a fast-evolving market."
                technologicalExpertiseCenter=" Moweb boasts a vast pool of technical expertise, specializing in Flutter cross-platform development and utilizing the latest development technologies to build robust, future-proof applications."
                privacyCommitment=" We place the highest importance on protecting your data. By adhering to stringent security protocols, we guarantee your project remains confidential and secure at every stage."
                flexibleHiringModels=" Choose from hourly, committed teams, or fixed-price engagement models. We offer flexible solutions that align with your project’s scope and budget, allowing you to hire Flutter developers according to your requirements."
                trustedOutsourcingPartner=" Moweb has earned a reputation as a trusted outsourcing partner for web and mobile development. With a proven track record of delivering successful projects, we ensure a smooth outsourcing experience from start to finish"
            />

            <ModelsOfWorking
                title="Engagement Models To Hire The Best Flutter Developers"
                desc="Select the best engagement model to hire Flutter developers for your specific business needs. Whether you need a dedicated team, fixed-cost project, or time and material arrangement, we offer flexible solutions that align with your requirements."
            />
            <TechnologyFaq title="FAQs On Flutter Development Services" bg="bg-flutterapp">
                <FlutterFAQ />
            </TechnologyFaq>
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
